const FundBox = require('./FundBox');

module.exports = FundBox;
